import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { faqData, FaqTab } from "./content";

const tabLabels: Record<FaqTab, string> = { mock: "Mock Interviews", internship: "Internships", workshop: "Workshops" };

export default function FaqSection() {
    const [tab, setTab] = useState<FaqTab>("mock");
    const [openIndex, setOpenIndex] = useState<number | null>(0);
    const tabs = Object.keys(tabLabels) as FaqTab[];

    const selectTab = (next: FaqTab) => {
        setTab(next);
        setOpenIndex(0);
    };

    return <section className="mz-section" id="faq">
        <div className="mz-container mz-faq-layout">
            <div className="mz-faq-intro">
                <p className="mz-section-label">Frequently Asked Questions</p>
                <h2 className="mz-section-title">Clear answers before you begin.</h2>
                <p className="mz-section-lead">Choose a program to see the questions students ask most often.</p>
                <div className="mz-faq-tabs" role="tablist">
                    {tabs.map((key) => <button key={key} className={tab === key ? "is-active" : ""} onClick={() => selectTab(key)} role="tab" aria-selected={tab === key}>{tabLabels[key]}</button>)}
                </div>
            </div>
            <div className="mz-faq-list">
                {faqData[tab].map((item, index) => {
                    const open = openIndex === index;
                    return <article className={open ? "is-open" : ""} key={item.question}>
                        <button onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={`faq-answer-${tab}-${index}`}>
                            <span>{item.question}</span><ChevronDown />
                        </button>
                        {open && <p id={`faq-answer-${tab}-${index}`}>{item.answer}</p>}
                    </article>;
                })}
            </div>
        </div>
    </section>;
}
